import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const WaitlistCard = ({ request, onApprove, onReject, onViewDetails }) => {
  const getScoreBadge = () => {
    if (request?.qualificationScore >= 80) return 'bg-success text-success-foreground';
    if (request?.qualificationScore >= 60) return 'bg-warning text-warning-foreground';
    return 'bg-error text-error-foreground';
  };

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 elevation-sm border border-border">
      <div className="flex items-start gap-3 md:gap-4 mb-4">
        <Image 
          src={request?.avatar} 
          alt={request?.avatarAlt}
          className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div>
              <h4 className="text-base md:text-lg font-semibold text-foreground line-clamp-1">
                {request?.name}
              </h4>
              <p className="text-sm text-muted-foreground line-clamp-1">{request?.email}</p>
            </div>
            <div className={`px-3 py-1 rounded-full text-sm font-semibold ${getScoreBadge()}`}>
              {request?.qualificationScore}%
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-3">
            <div className="flex items-center gap-2">
              <Icon name="Briefcase" size={14} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">{request?.experience}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={14} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">{request?.location}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Building2" size={14} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">{request?.industry}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={14} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">{request?.requestDate}</span>
            </div>
          </div>

          <div className="bg-muted/50 rounded-lg p-3 mb-3">
            <p className="text-xs text-muted-foreground mb-1">Reason for Request</p>
            <p className="text-sm text-foreground line-clamp-2">{request?.reason}</p>
          </div>

          {request?.recommendation && (
            <div className="flex items-start gap-2 mb-3">
              <Icon name="Lightbulb" size={16} className="text-accent mt-0.5 flex-shrink-0" />
              <p className="text-sm text-accent">{request?.recommendation}</p>
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          iconName="FileText" 
          iconPosition="left"
          onClick={() => onViewDetails(request)}
          className="flex-1"
        >
          View Full Profile
        </Button>
        <Button 
          variant="success" 
          size="sm" 
          iconName="Check" 
          iconPosition="left"
          onClick={() => onApprove(request)}
          className="flex-1"
        >
          Grant Access
        </Button>
        <Button 
          variant="destructive" 
          size="sm" 
          iconName="X" 
          iconPosition="left"
          onClick={() => onReject(request)}
          className="flex-1"
        >
          Reject
        </Button>
      </div>
    </div>
  );
};

export default WaitlistCard;